import React, { Component } from 'react';
import b_ from 'b_';
import cn from 'classnames';
import PropTypes from 'prop-types';
import FuseButton from '../FuseControls/FuseButton';
import './UrlGuidelines.css';

const block = b_.lock('UrlGuidelines');

export default class DomainGuidelines extends Component {
    static propTypes = {
        header: PropTypes.string,
        onClose: PropTypes.func.isRequired,
        className: PropTypes.string,
    };

    render() {
        const { header, onClose, className } = this.props;

        return <div className={cn(block(), className)}>
            <div className={block('Header')}>
                {header || 'Syntax Requirements for Adding Email Domains'}
                <FuseButton icon="close" primary className={block('Close')} onClick={onClose} />
            </div>
            <div className={block('Content')}>
                <p>
                    Email Domains are defined by match patterns consisting of two parts:
                </p>
                <p>
                    <b>1. Domain Name</b>{' - for example: google or gmail'}<br />
                    <b>2. Domain Extension</b>{' - for example: .com or .org'}<br />
                </p>
                <p>
                    <b>Example:</b>{' sender.com'}
                    <br /><br />
                    If you specify only the root of a domain, the system will match with email senders from all
                    subdomains. For example, sender.com will match with user@sender.com and user@test.sender.com
                    <br /><br />
                    If you add a subdomain, the system will ONLY match with email senders from that subdomain.
                    For example, test.sender.com will match with user@test.sender.com and NOT user@sender.com
                    <br /><br />
                    <b>NOTE:</b> Wildcard syntax is not supported.
                </p>
            </div>
        </div>;
    }
}
